module.exports = __webpack_public_path__ + "img/company.641cd586.png";